module.exports = __webpack_public_path__ + "static/media/DASHPORT_isotipo_W.6fa277b6.png";